import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { UnsavedChangesTrackerService } from '../services/unsaved-changes-tracker.service';

export const preventUnsavedChangesGuard: CanDeactivateFn<unknown> = () => {
  const unsavedChangesService = inject(UnsavedChangesTrackerService);
  const unsavedData = unsavedChangesService.anyUnsavedChanges();
  if (!unsavedData) {
    return true;
  }
  return new Observable<boolean>((observer) => {
    unsavedChangesService.showUnsavedChanges({
      onLeave: () => {
        unsavedChangesService.clearAllUnsavedChanges();
        observer.next(true);
        observer.complete();
      },
      onStay: () => {
        observer.next(false);
        observer.complete();
      },
    });
  });
};
